import type {BioIconProps} from './common-types'

export function IconMail({...attributes}: BioIconProps) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M29.3327 8.0026C29.3327 6.53594 28.1327 5.33594 26.666 5.33594H5.33268C3.86602 5.33594 2.66602 6.53594 2.66602 8.0026V24.0026C2.66602 25.4693 3.86602 26.6693 5.33268 26.6693H26.666C28.1327 26.6693 29.3327 25.4693 29.3327 24.0026V8.0026ZM26.666 8.0026L15.9993 14.6693L5.33268 8.0026H26.666ZM26.666 24.0026H5.33268V10.6693L15.9993 17.3359L26.666 10.6693V24.0026Z"
        fill="black"
      />
    </svg>
  )
}
